import React from 'react';

import { map } from 'lodash';
import { getLabel } from 'utils/getLabel';
import { withNetworkState } from 'ui/hoc/withNetworkState';
import { CallWidgetCategoryReasonSummaryList } from 'ui/containers/CallWidgetCategoryReasonSummaryList';

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { callWidgetCategoryReasonSummary as CallWidgetCategoryReasonSummary } from 'ui/views/widgets/callWidgetCategoryReasonSummary';
 *
 * // render
 * <CallWidgetCategoryReasonSummary propName='propValue'/>
 */
export const callWidgetCategoryReasonSummarySuccess = ( props ) => {

    const { widget } = props.componentData;

    return (
        <div className='ui-call-widget-category-reason-summary'>
        {/* title */}
        <p className='ui-call-widget-category-reason-summary__title'>
            { getLabel( widget.title ) }
        </p>
             
        <CallWidgetCategoryReasonSummaryList {...props.componentData} requestPayload = { props.requestPayload }/>
        </div>
    );
};

// set display name
callWidgetCategoryReasonSummarySuccess.displayName = 'callWidgetCategoryReasonSummarySuccess';

// set default props
callWidgetCategoryReasonSummarySuccess.defaultProps = {};

// prop types
callWidgetCategoryReasonSummarySuccess.propTypes = {};


export const callWidgetCategoryReasonSummaryPreloader = ( ) => {

    return (
            <div className='ui-call-widget-category-reason-summary-preloader'>
                 <div className='ui-call-widget-category-reason-summary-preloader__title'/>
                { map( [ 1, 2, 3, 4  ], ( item ) => {
                    return (
                        <div key={ item } className="ui-call-widget-category-reason-summary-preloader__card">
                            <div className='ui-call-widget-category-reason-summary-preloader__card__parent'/>
                            <div className='ui-call-widget-category-reason-summary-preloader__card__children'/>
                        </div>
                    );
                } )
            }
            </div>
    );
};

// set display name
callWidgetCategoryReasonSummaryPreloader.displayName = 'callWidgetCategoryReasonSummaryPreloader';

// set default props
callWidgetCategoryReasonSummaryPreloader.defaultProps = {};

// prop types
callWidgetCategoryReasonSummaryPreloader.propTypes = {};

export const callWidgetCategoryReasonSummary = withNetworkState( callWidgetCategoryReasonSummaryPreloader, callWidgetCategoryReasonSummarySuccess );
